import { createRouter, createWebHashHistory } from 'vue-router'
const routerHistory = createWebHashHistory()
import { getToken, setToken } from "../utils/auth"
const router = createRouter({
  history: routerHistory,
  routes: [
    {
      path: '/',
      component: () => import('../view/home/index.vue')
    },
    {
      path: '/login',
      component: () => import('../view/login.vue')
    }
  ]
})

export default router
